import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosPatch,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllBlogCategoryResponse,
  getBlogCategoryByIdResponse,
  getActiveBlogCategoryResponse,
} from "../actions";

export function* createBlogCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`blog-category`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "BlogCategory saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateBlogCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(
        `blog-category/${action.data?.payload?.id}`,
        action.data?.payload
      )
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "BlogCategory updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllBlogCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`blog-category/all`));
    yield put(getAllBlogCategoryResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllBlogCategoryResponse([]));
  }
}

export function* getBlogCategoryByIdEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`blog-category/${action.payload?.id}`)
    );
    yield put(getBlogCategoryByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getBlogCategoryByIdResponse([]));
  }
}

export function* deleteBlogCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosDelete(`blog-category/${action.payload?.id}`)
    );
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "BlogCategory deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getActiveBlogCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`blog-category/active`));
    yield put(getActiveBlogCategoryResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getActiveBlogCategoryResponse([]));
  }
}

export function* blogCategoryWatcherSaga() {
  yield takeLatest(types.CREATE_BLOG_CATEGORY, createBlogCategoryEffectSaga);
  yield takeLatest(types.UPDATE_BLOG_CATEGORY, updateBlogCategoryEffectSaga);
  yield takeLatest(types.GET_ALL_BLOG_CATEGORY, getAllBlogCategoryEffectSaga);
  yield takeLatest(
    types.GET_BLOG_CATEGORY_BY_ID,
    getBlogCategoryByIdEffectSaga
  );
  yield takeLatest(types.DELETE_BLOG_CATEGORY, deleteBlogCategoryEffectSaga);
  yield takeLatest(
    types.GET_ACTIVE_BLOG_CATEGORY,
    getActiveBlogCategoryEffectSaga
  );
}
